import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

export const APOLLO_LOGO = 'https://customer-assets-4nw71qhi.emergentagent.net/job_roller-shade-builder/artifacts/60216516cf9dc493_Apollo%20Logopng.png';

const rise = (delay) => ({
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] },
});

// Shared "Select a fabric to preview" card: Apollo logo + message, soft staggered fade-in (compact on phones)
export const EmptyPreviewCard = ({ hint = 'Choose a brand, type, collection and color in step 1', typeLabel, colorCount, onChooseFabric, className = '' }) => (
  <motion.div {...rise(0)} className={`bg-white rounded-2xl px-5 py-4 sm:px-8 sm:py-7 text-center shadow-xl w-[88%] sm:w-[85%] max-w-md flex flex-col items-center ${className}`} data-testid="preview-empty-card">
    <motion.img {...rise(0.15)} src={APOLLO_LOGO} alt="The Apollo Custom Smart Shades" className="w-24 h-24 sm:w-40 sm:h-40 object-contain -my-2 sm:-my-3" data-testid="preview-empty-logo" />
    <motion.p {...rise(0.3)} className="text-lg sm:text-2xl font-semibold text-neutral-900 mt-1 sm:mt-2 leading-tight" data-testid="preview-empty-title">Select a fabric to preview</motion.p>
    {typeLabel ? (
      <motion.p key={typeLabel} {...rise(0.1)} className="text-sm sm:text-base text-neutral-600 mt-1 sm:mt-2" data-testid="preview-empty-type-hint">
        <span className="font-semibold text-amber-700">{typeLabel}</span> — {colorCount ? `${colorCount} color${colorCount === 1 ? '' : 's'} to choose from` : 'now pick a color'}
      </motion.p>
    ) : (
      <motion.p {...rise(0.4)} className="text-sm sm:text-base text-neutral-600 mt-1 sm:mt-2" data-testid="preview-empty-hint">{hint}</motion.p>
    )}
    {onChooseFabric && (
      <motion.button type="button" onClick={onChooseFabric}
        initial={{ opacity: 0, y: 10, scale: 1, boxShadow: '0 0 0 0 rgba(180,83,9,0)' }}
        animate={{ opacity: 1, y: 0, scale: [1, 1.07, 1], boxShadow: ['0 0 0 0 rgba(180,83,9,0.45)', '0 0 0 10px rgba(180,83,9,0)', '0 0 0 0 rgba(180,83,9,0)'] }}
        transition={{ opacity: { duration: 0.6, delay: 0.5 }, y: { duration: 0.6, delay: 0.5, ease: [0.22, 1, 0.36, 1] },
          scale: { duration: 0.9, delay: 1.3, ease: 'easeInOut' }, boxShadow: { duration: 1.2, delay: 1.3, ease: 'easeOut' } }}
        className="group mt-3 sm:mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-neutral-900 px-5 py-2 sm:px-6 sm:py-2.5 text-sm font-medium text-white transition-colors hover:bg-amber-700"
        data-testid="preview-choose-fabric-btn">
        Choose your fabric
        <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
      </motion.button>
    )}
  </motion.div>
);
